const dictionary = {
    is: {
        "Garantiekapital_perspektive": "Tryggður höfuðstóll",
        "garantierte Mindestleistung inklusive Zulagen": "Tryggður höfuðstóll",
        "Gesamtkapital": "Áætluð inneign við samningslok",
        "Gesamtkapital_kd": "Áætluð eingreiðsla",
        "GesamtkapitalPlusProz": "Áætluð inneign við 1% hærri ávöxtun",
        "garantierte Mindestrente inklusive Zulagen": "Tryggður mánaðarlegur lífeyrir",
        "GesamteRente": "Áætlaður mánaðarlegur lífeyrir við samningslok",
        "GesamteRente_kd": "Áætlaður mánaðarlegur lífeyrir",
        "GesamtrentePlusProz": "Áætlaður mánaðarlegur lífeyrir við samningslok við 1% hærri ávöxtun",
        "Garantiekapital": "Líftrygging",
        "Garantiekapital_kd": "Tryggð eingreiðsla",
        "startDate": "Upphafsdagur",
        "endDate": "Samningslok",
        "contractLength": "Samningstími",
        "totalPayments": "Greitt inn á tímabilinu",
        "Gesamtleistung bei Rückkauf": "Tryggt uppsagnarvirði",
        "Laufende Gesamtrente der HV gemäß Rentenzw": "Lífeyrisgreiðsla á mánuði",
        "Ges.Leistung bei Tod in der Rentenlaufzeit": "Greiðsla við andlát",
        "Gesamtleistung bei Rückkauf": "Tryggt uppsagnarvirði *",
        "monthlyPayment": "Greitt inn á tímabilinu",
        "postLifetimeHeading": "Útreikningur lífeyristryggingar eftir að lífeyrisgreiðslur eru hafnar",
        "lifetimeHeading": "Þróun tryggingar",
        "Expired transaction": "Rann út á tíma.",
        "User cancelled request": "Notandi hætti við",
        'UZ': 'Iðgjald vegna dánarbóta v/slyss',
        'RSKU2': 'Iðgjald í söfnun',
        'RSKU2/KD': 'Iðgjald í söfnun',
        'Hauptprodukt': 'Heildar iðgjald til greiðslu',
        'monthlyCapitalByDeath': 'Iðgjald vegna líftryggingar',
        "kapitalBeiUnfalltod": 'Dánarbætur v/slyss',
        "GarantierteTodesfallleistungUnfallTod": 'Dánarbætur v/slyss',
        'kapitalBeiTod': 'Lítrygging',
        "BeitragBeiUnfalltod": "Mánaðarlegt iðgjald dánarbóta v/slyss",
        "beitrag": "Iðgjald",
        "TotalHauptprodukt": "Iðgjald",
        "GarantierteTodesfallleistung": "Grunnlíftrygging",
        "LC0": "Iðgjald líftryggingar",
        "Ges. Einmalzahlung bei Tod am Anfang des Vers.-Jahres": 'Endurgreiðsla við andlát',
        "Fondswert (Todesfallleistung) mit -1% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit -0.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 0% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 0.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 1% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 1.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 2% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 2.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 3% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 3.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 4% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 4.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 5.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 6% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 6.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 7% Fondswertsteigerung": "Greiðsla við andlát",
        "Fondswert (Todesfallleistung) mit 7.5% Fondswertsteigerung": "Greiðsla við andlát",
        "Gesamtleistung bei Rückkauf bei -1% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei -0.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 0% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 0.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 1% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 1.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 2% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 2.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 3% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 3.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 4% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 4.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 5.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 6% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 6.5% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 7% Wertsteigerung": "Uppsagnarvirði",
        "Gesamtleistung bei Rückkauf bei 7.5% Wertsteigerung": "Uppsagnarvirði",
        "Rückkaufswert": "Uppsagnarvirði",
        "kdGarantieProzent": "Trygging sem hlutfall af inngreiddum iðgjöldum",
        "ris.amountHeading": "Bótafjárhæðir",
        "ris.disability_amount": "Upphæð örorkubóta",
        "ris.disability_fivefold_amount": "Hámarks örorkubætur við 50% örorku",
        "ris.disability_fivefold_amount_100": "Hámarks örorkubætur við 100% örorku",
        "ris.monthly_pension": "Mánaðarlegur tekjulífeyrir til æviloka við 50% örorku",
        "ris.acute_benefits": "Bráðabætur",
        "ris.acute_benefits_sub_1": " - brotinn fingur, brotin tá",
        "ris.acute_benefits_sub_2": " - brotinn handleggur, fótleggur, fótur, brotin öxl, hönd",
        "ris.acute_benefits_sub_3": " - brotin mjaðmagrind, mjöðm eða brotinn hryggur",
        "ris.hospital_pension_1_3": "Sjúkrahúsdagpeningar",
        "ris.hospital_pension_1_3_sub_1": " - á dag vegna slyss, 1.-3. dagur",
        "ris.hospital_pension_1_3_sub_2": " - á dag vegna slyss, frá og með 4. degi",
        "ris.hospital_pension_1_3_sub_3": " - Aðgerð án innlagnar",
        "ris.accidental_death_benefits": "Dánarbætur vegna slyss",
        "ris.plastic_surgery": "Lýtaaðgerðir allt að",
        "ris.rescue_cost": "Björgunarkostnaður allt að",
        "ris.immediate_benefits": "Tafarlausar bætur",
        "ris.prostheses": "Kostnaður vegna stoðtækja allt að",
        "ris.monthly_payment": "Mánaðarlegt iðgjald",
        "ris.quarterly_payment": "Ársfjórðungslegt iðgjald",
        "ris.biannual_payment": "Hálfsárslegt iðgjald",
        "ris.annual_payment": "Árlegt iðgjald",
        "ksp.amountHeading": "Tryggingarvernd",
        "ksp.monthly_payment": "Mánaðarlegur tekjulífeyrir",
        "ksp.monthly_payment_subtext": "Vegna skerðingar á líkamlegri eða andlegri getu",
        "ksp.onetime": "Eingreiðsla við alvarlega sjúkdóma",
        "ren.onetime": "Eingreiðsla",
        "riskGroup": "Áhættuflokkur",
    },
    de: {
        "Garantiekapital_perspektive": "Garantiekapital bei Erleben",
        "garantierte Mindestleistung inklusive Zulagen": "Garantiekapital bei Erleben",
        "Gesamtkapital": "Gesamtkapital",
        "Gesamtkapital_kd": "Gesamtkapital",
        "GesamtkapitalPlusProz": "Mögliches Gesamtkapital bei 1% über den derzeitig liegenden Überschussanteilsätzen",
        "garantierte Mindestrente inklusive Zulagen": "Garantierte Mindesrente",
        "GesamteRente": "GesamteRente",
        "GesamteRente_kd": "GesamteRente",
        "GesamtrentePlusProz": "Mögliches monatliche Gesamtrente bei 1% über den derzeitig liegenden Überschussanteilsätzen",
        "Garantiekapital": "Kapital bei Tod",
        "Garantiekapital_kd": "Garantiekapital bei Erleben",
        "startDate": "Versicherungsbeginn",
        "endDate": "Beginn der Rentenzahlung",
        "contractLength": "Aufschub-/Beitragszahlungsdauer",
        "totalPayments": "Beitragssumme",
        "Gesamtleistung bei Rückkauf": "Gesamtleistung bei Rückkauf",
        "Laufende Gesamtrente der HV gemäß Rentenzw": "Laufende Gesamtrente der HV gemäß Rentenzw",
        "Ges.Leistung bei Tod in der Rentenlaufzeit": "Ges.Leistung bei Tod in der Rentenlaufzeit",
        "Gesamtleistung bei Rückkauf": "Garantieleistung bei Rückkauf",
        "monthlyPayment": "Beitragssumme",
        "postLifetimeHeading": "Modellrechnung der Verlaufswerte ab dem Rentenbeginn",
        "lifetimeHeading": "Modellrechnung der Verlaufswerte bis zum Rentenbeginn",
        'UZ': 'Kapital bei Unfalltod',
        'RSKU2': 'Zukunftsrente Perspektive',
        'RSKU2/KD': 'Zukunftsrente Komfort Dynamik',
        'Hauptprodukt': 'zu zahlender Gesamtbeitrag',
        'monthlyCapitalByDeath': 'Kapital bei Tod',
        'kapitalBeiUnfalltod': 'Kapital bei Unfalltod',
        "GarantierteTodesfallleistungUnfallTod":'Kapital bei Unfalltod',
        'kapitalBeiTod': 'Kapital bei Tod',
        "BeitragBeiUnfalltod": "Beitrag - Kapital bei Unfalltod",
        "beitrag": "Beitrag",
        'TotalHauptprodukt': 'zu zahlender Beitrag',
        "GarantierteTodesfallleistung": "Kapital bei Tod",
        "LC0": "Beitrag - Kapital bei Tod",
        "Ges. Einmalzahlung bei Tod am Anfang des Vers.-Jahres": "Leistung bei Tod",
        "Fondswert (Todesfallleistung) mit 4.5% Fondswertsteigerung": "Leistung bei Tod",
        "Gesamtleistung bei Rückkauf bei 4.5% Wertsteigerung": "Rückkaufswert",
        "kdGarantieProzent": "Garantie in Prozent der Altersvorsorgebeiträge",
        "ris.amountHeading": "Geldleistungen aus der dynamischen Unfallversicherung",
        "ris.disability_amount": "Invaliditätssumme",
        "ris.disability_fivefold_amount": "Invaliditätsleistung ab 50% Invalidität",
        "ris.disability_fivefold_amount_100": "Invaliditätsleistung ab 100% Invalidität",
        "ris.monthly_pension": "Unfallrente",
        "ris.acute_benefits": "Akutleistung",
        "ris.acute_benefits_sub_1": "bei Bruch eines Fingers, einer Zehe",
        "ris.acute_benefits_sub_2": "bei Bruch eines Armes, einer Schulter, Hand, Bein, eines Fußes",
        "ris.acute_benefits_sub_3": "bei einem Becken-, Wirbel- oder Hüftbruch",
        "ris.hospital_pension_1_3": "Krankenhaustagegeld",
        "ris.hospital_pension_1_3_sub_1": "vom 1. bis 3. Tag jeweils",
        "ris.hospital_pension_1_3_sub_2": "ab 4. Tag jeweils",
        "ris.hospital_pension_1_3_sub_3": "für ambulante Operationen einmalig",
        "ris.accidental_death_benefits": "Todesfallleistung",
        "ris.plastic_surgery": "Kosmetische Operationen bis zu",
        "ris.rescue_cost": "Bergungskosten",
        "ris.immediate_benefits": "Sofortleistung",
        "ris.prostheses": "Kosten für Hilfsmittel",
        "ris.monthly_payment": "Monatlicher Gesamtbeitrag",
        "ris.quarterly_payment": "Vierteljährlicher Gesamtbeitrag",
        "ris.biannual_payment": "Halbjährlicher Gesamtbeitrag",
        "ris.annual_payment": "Jährlicher Gesamtbeitrag",
        "ksp.amountHeading": "Leistungen aus der KörperSchutzPolice",
        "ksp.monthly_payment": "",
        "ksp.monthly_payment_subtext": "Rente bei Beeinträchtigung von körperlichen oder geistigen Fähigkeiten",
        "ksp.onetime": "",
        "ren.onetime": "Einmalbetrag",
        "riskGroup": "Gefahrengruppe",
    }
}

export const gettext = (sourceStr, lang='is') => {
    if (dictionary[lang][sourceStr] !== undefined) {
        return dictionary[lang][sourceStr]
    }
    return sourceStr
}

window.translate = gettext;